import { AppFeature } from '../app-feature/app-feature';
import { OAuthProperties } from '../auth/auth.service';
import { GetAppContext } from '../auth/GetAppContext';
import { Tooltip } from '../tooltip/Tooltip';

export interface AppContextState {
    isLoading: boolean;
    appContext: GetAppContext | undefined;
    oAuthProperties: OAuthProperties | undefined;
    tooltips: Tooltip[];
    appFeatures: AppFeature[];
}

export const initialState: AppContextState = {
    isLoading: false,
    appContext: undefined,
    oAuthProperties: undefined,
    tooltips: [],
    appFeatures: []
};

export const featureKey = 'coreModule';
